module.exports = __webpack_public_path__ + "img/inge-v6-char-3.5353b3ad.png";